/**
 * CartBar — the floating "Go to cart" pill that appears when the cart has
 * items. Compact and raised a little above the bottom nav so it reads as a
 * floating card rather than a full-width bar.
 */

import { Link } from 'react-router-dom';
import { ShoppingCart, ChevronRight } from 'lucide-react';
import { formatCurrency } from '@rocket07/shared';
import { useCart } from '@/context/CartContext';
import { ROUTES } from '@/constants/routes';

export function CartBar() {
  const { itemCount, subtotal } = useCart();

  if (itemCount === 0) return null;

  return (
    // bottom-20 lifts it above the bottom nav; max-w-md keeps it a compact card.
    <div className="fixed inset-x-0 bottom-20 z-30 px-4 lg:bottom-6">
      <Link
        to={ROUTES.cart}
        className="animate-slide-up mx-auto flex max-w-md items-center gap-2.5 rounded-2xl bg-primary-500 px-3.5 py-2.5 text-ink shadow-pop transition-transform active:scale-[0.99]"
      >
        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-white text-ink shadow-sm">
          <ShoppingCart size={18} />
        </span>
        <span className="flex-1 leading-tight">
          <span className="block text-sm font-bold">
            {itemCount} {itemCount === 1 ? 'item' : 'items'} · {formatCurrency(subtotal)}
          </span>
          <span className="text-[11px] text-ink/70">Go to cart</span>
        </span>
        <ChevronRight size={20} className="shrink-0" />
      </Link>
    </div>
  );
}

export default CartBar;
